<script>
import { extend, ValidationProvider } from 'vee-validate'
import { required, email, numeric, min_value as minValue, max_value as maxValue } from 'vee-validate/dist/rules'

extend('required', required)
extend('email', email)
extend('numeric', numeric)
extend('min_value', minValue)
extend('max_value', maxValue)

export default {
    name: 'BaseField',
    components: {
        ValidationProvider
    },
    props: {
        value: [String, Number, Boolean, Object],
        rules: [Object, String],
        required: Boolean,
        email: String
    },
    computed: {
        isRequired() {
            return (this.required || (this.rules && this.rules.required) || (this.rules && this.rules.indexOf('required') > -1))
        }
    }
}
</script>
